export const returnFocusToBody = (): void => {
	document.body.focus();
};
